import React, { useEffect, useState } from "react";
import { getCurrentUser } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { validateAndRefreshTokens, handleAuthError } from '../utils/authUtils';

function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        // Validate and refresh tokens if needed
        const hasValidTokens = await validateAndRefreshTokens();
        if (hasValidTokens) {
          setIsAuthenticated(true);
        } else {
          throw new Error('Invalid tokens');
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        await handleAuthError();
        setIsAuthenticated(false);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  if (loading) return <div style={{ textAlign: "center", paddingTop: "4rem" }}>Loading...</div>;
  return isAuthenticated ? children : null;
}

export default ProtectedRoute;
